import {bookingImportConstants} from "../../../../constants/General/bookingImport.constants";

const initialState = {
    fetching: false,
    setupData: null,
    setupError: false,
    statusFetching: false,
    statusData: null,
    statusError: false,
    checkFetching: false,
    checkData: null,
    checkError: false,
    photoSearchFetching: false,
    photoSearchData: null,
    photoSearchError: false,
    photoSaveFetching: false,
    photoSaveData: null,
    photoSaveError: false,
    facilitySearchFetching: false,
    facilitySearchData: null,
    facilitySearchError: false,
    facilitySaveFetching: false,
    facilitySaveData: null,
    facilitySaveError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case bookingImportConstants.BOOKING_IMPORT_SETUP_PENDING:
            return {
                ...state,
                fetching: true,
                setupData: null,
                setupError: false,
            };
        case bookingImportConstants.BOOKING_IMPORT_SETUP_FULFILLED:
            return {
                ...state,
                fetching: false,
                setupError: false,
                setupData: action.payload,
            };
        case bookingImportConstants.BOOKING_IMPORT_SETUP_REJECTED:
            return {
                ...state,
                fetching: false,
                setupError: action.payload,
            };

        case bookingImportConstants.BOOKING_IMPORT_STATUS_PENDING:
            return {
                ...state,
                statusFetching: true,
                statusError: false,
            };
        case bookingImportConstants.BOOKING_IMPORT_STATUS_FULFILLED:
            return {
                ...state,
                statusFetching: false,
                statusError: false,
                statusData: action.payload,
            };
        case bookingImportConstants.BOOKING_IMPORT_STATUS_REJECTED:
            return {
                ...state,
                statusFetching: false,
                statusError: action.payload,
            };

        case bookingImportConstants.BOOKING_IMPORT_CHECK_PENDING:
            return {
                ...state,
                checkFetching: true,
                checkError: false,
            };
        case bookingImportConstants.BOOKING_IMPORT_CHECK_FULFILLED:
            return {
                ...state,
                checkFetching: false,
                checkError: false,
                checkData: action.payload,
            };
        case bookingImportConstants.BOOKING_IMPORT_CHECK_REJECTED:
            return {
                ...state,
                checkFetching: false,
                checkError: action.payload,
            };

        case bookingImportConstants.BOOKING_PHOTO_SEARCH_PENDING:
            return {
                ...state,
                photoSearchFetching: true,
                photoSearchData: null,
                photoSearchError: false,
            };
        case bookingImportConstants.BOOKING_PHOTO_SEARCH_FULFILLED:
            return {
                ...state,
                photoSearchFetching: false,
                photoSearchError: false,
                photoSearchData: action.payload,
            };
        case bookingImportConstants.BOOKING_PHOTO_SEARCH_REJECTED:
            return {
                ...state,
                photoSearchFetching: false,
                photoSearchError: action.payload,
            };

        case bookingImportConstants.BOOKING_PHOTO_SAVE_PENDING:
            return {
                ...state,
                photoSaveFetching: true,
                photoSaveData: null,
                photoSaveError: false,
            };
        case bookingImportConstants.BOOKING_PHOTO_SAVE_FULFILLED:
            return {
                ...state,
                photoSaveFetching: false,
                photoSaveError: false,
                photoSaveData: action.payload,
            };
        case bookingImportConstants.BOOKING_PHOTO_SAVE_REJECTED:
            return {
                ...state,
                photoSaveFetching: false,
                photoSaveError: action.payload,
            };

        case bookingImportConstants.BOOKING_IMPORT_CLEAR:
            return {
                ...initialState,
            };
        case bookingImportConstants.BOOKING_PHOTO_CLEAR:
            return {
                ...state,
                photoSearchFetching: false,
                photoSearchData: null,
                photoSearchError: false,
                photoSaveFetching: false,
                photoSaveData: null,
                photoSaveError: false,
            };

        case bookingImportConstants.BOOKING_FACILITY_SEARCH_PENDING:
            return {
                ...state,
                facilitySearchFetching: true,
                facilitySearchData: null,
                facilitySearchError: false,
            };
        case bookingImportConstants.BOOKING_FACILITY_SEARCH_FULFILLED:
            return {
                ...state,
                facilitySearchFetching: false,
                facilitySearchError: false,
                facilitySearchData: action.payload,
            };
        case bookingImportConstants.BOOKING_FACILITY_SEARCH_REJECTED:
            return {
                ...state,
                facilitySearchFetching: false,
                facilitySearchError: action.payload,
            };

        case bookingImportConstants.BOOKING_FACILITY_SAVE_PENDING:
            return {
                ...state,
                facilitySaveFetching: true,
                facilitySaveData: null,
                facilitySaveError: false,
            };
        case bookingImportConstants.BOOKING_FACILITY_SAVE_FULFILLED:
            return {
                ...state,
                facilitySaveFetching: false,
                facilitySaveError: false,
                facilitySaveData: action.payload,
            };
        case bookingImportConstants.BOOKING_FACILITY_SAVE_REJECTED:
            return {
                ...state,
                facilitySaveFetching: false,
                facilitySaveError: action.payload,
            };

        case bookingImportConstants.BOOKING_FACILITY_CLEAR:
            return {
                ...state,
                facilitySearchFetching: false,
                facilitySearchData: null,
                facilitySearchError: false,
                facilitySaveFetching: false,
                facilitySaveData: null,
                facilitySaveError: false,
            };
        case "CLEAR_STATE":
            return {
                ...initialState
            };
        default:
            return state;
    }
}
